import { render, staticRenderFns } from "./refill_product.vue?vue&type=template&id=28178ced&scoped=true&"
import script from "./refill_product.vue?vue&type=script&lang=js&"
export * from "./refill_product.vue?vue&type=script&lang=js&"
import style0 from "./refill_product.vue?vue&type=style&index=0&id=28178ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28178ced",
  null
  
)

export default component.exports